import React from 'react';
import {
  accessToServices,
  jurisdictions,
  licenceRestrictions,
  licenceRestrictionsIncludesFreeTrialTerms,
  licenceRestrictionsMustNotFreeTrialTerms,
  licenceToUsePlataform,
  limitationOfLiability,
  limitedWarranty,
  terms,
  transferTemsforExistingClients,
  multiFactorAuth,
} from './constants/data';
import TermsTable from './TermsTable';
import {
  TermsContainer,
  TermsHeading,
  TermsSubHeading,
  TermsText,
} from './TermsAndConditions.styles';
import TermsListComponent from './TermsList';

const TermsAndConditions = () => {
  return (
    <TermsContainer>
      <TermsText>
        These terms (“<strong>Gateway General Terms of Use</strong>”), together with any applicable
        Product Specific Terms (as defined in clause 6 below) (collectively, the “
        <strong>Terms</strong>”), govern the use of the Gateway platform (“<strong>Gateway</strong>
        ”) for the provision of VANTAGE Services, including where existing clients are transitioning
        to Gateway (“<strong>Existing VANTAGE Clients</strong>”) and, if applicable, any Free Trial
        granted by the Company at its sole discretion. The Terms are a binding agreement between you
        (“
        <strong>End User</strong> or <strong>you</strong>”) and Control Risks Group Limited, its
        affiliates, subsidiaries and its agents (“
        <strong>Control Risks</strong>”).
      </TermsText>
      <TermsText style={{ textTransform: 'uppercase' }}>
        BY CLICKING THE “AGREE” BUTTON YOU:
      </TermsText>
      <TermsListComponent items={terms} />

      {/* */}
      <TermsHeading>Your Agreement with Control Risks</TermsHeading>
      <TermsSubHeading>1. Choice of Law and Contracting Entity</TermsSubHeading>
      <TermsText>
        The construction and performance of the Terms shall be governed by the following (without
        regard to any such jurisdiction’s choice or conflict of laws principles). The law that will
        apply in any dispute or lawsuit arising out of or in connection with the Terms, and the
        courts that have jurisdiction over any such dispute or lawsuit, shall be governed by the
        region in which the Control Risks contracting entity’s registered office is located.
      </TermsText>
      <TermsTable items={jurisdictions} />

      {/* */}
      <br />
      <TermsSubHeading>2. Licence to use Gateway</TermsSubHeading>
      <TermsText>
        Subject to your compliance with the Terms and applicable law, Control Risks grants you a
        non-exclusive, non-transferable, limited, revocable right (as set forth herein) to:
      </TermsText>
      <TermsListComponent items={licenceToUsePlataform} />

      {/* */}
      <TermsSubHeading>3. Licence Restrictions</TermsSubHeading>
      <TermsText>You shall not:</TermsText>
      <TermsListComponent items={licenceRestrictions} />
      <TermsText>Each licence is to be used by only one (1) person and cannot be shared.</TermsText>

      {/* */}
      <br />
      <TermsSubHeading>4. Reservation of Rights</TermsSubHeading>
      <TermsText>
        You acknowledge and agree that Gateway is provided under licence and not sold to you. You do
        not acquire any ownership interest in the Platform under the Terms, or any other rights
        thereto other than to use Gateway in accordance with the licence granted, and subject to all
        terms, conditions, and restrictions, under the Terms. Company reserves and shall retain its
        entire right, title, and interest in and to Gateway, including all copyrights, trademarks,
        and other intellectual property rights therein or relating thereto, except as expressly
        granted to you in the Terms.
      </TermsText>

      {/* */}
      <br />
      <TermsSubHeading>5. Termination of Licence</TermsSubHeading>
      <TermsText>
        Control Risks may, in its sole and absolute discretion, at any time and for any or no
        reason, suspend or terminate this licence and the rights afforded to you hereunder with or
        without prior notice. Furthermore, if you fail to comply with the Terms of this licence,
        then this licence and any rights afforded to you hereunder shall terminate automatically,
        without any notice or other action by Control Risks. Upon the termination of this licence,
        you shall cease all use of Gateway.
      </TermsText>

      {/* */}
      <br />
      <TermsSubHeading>6. Product-Specific Terms</TermsSubHeading>
      <TermsText>
        The VANTAGE Services and Gateway are licensed, not sold, to you and may also be subject to
        one or more of the additional terms below (“
        <strong>Product Specific Terms</strong>”). If there is any conflict between the Gateway
        General Terms of Use and the Product Specific Terms, the Product Specific Terms govern. The
        Product Specific Terms are subject to change as described in clause 9 (Updates) below.
        Product Specific Terms may also be referred to as “<strong>Additional Terms</strong>” and
        are linked below:
      </TermsText>
      <TermsText>
        {' '}
        <a
          href="https://file-eu.clickdimensions.com/controlriskscom-agyes/files/2025-01-08-vantagegeneraltermsandconditions-final.pdf?m=1/13/2025%2012:58:29%20PM"
          tabIndex="-1"
          style={{ marginLeft: '20px' }}
        >
          VANTAGE General Tems and Conditions
        </a>
        <br />
        <br />
        <a
          href="https://app-eu.clickdimensions.com/blob/controlriskscom-agyes/files/vantageservicesdescriptiontemplatevantagediligence01.10.23.pdf"
          tabIndex="-1"
          style={{ marginLeft: '20px' }}
        >
          VANTAGE Diligence
        </a>
        <br />
        <br />
        <a
          href="https://app-eu.clickdimensions.com/blob/controlriskscom-agyes/files/vantageservicesdescriptiontemplatevantagescreening01.10.23.pdf"
          tabIndex="-1"
          style={{ marginLeft: '20px' }}
        >
          VANTAGE Screening
        </a>
        <br />
        <br />
        <a
          href="https://app-eu.clickdimensions.com/blob/controlriskscom-agyes/files/vantageservicesdescriptiontemplatevantagecompliancesolutions01.10.23.pdf"
          tabIndex="-1"
          style={{ marginLeft: '20px' }}
        >
          VANTAGE Compliance Solutions
        </a>
        <br />
        <br />
        <a
          href="https://app-eu.clickdimensions.com/blob/controlriskscom-agyes/files/vantageservicesdescriptiontemplatevantageplatform01.10.23.pdf"
          tabIndex="-1"
          style={{ marginLeft: '20px' }}
        >
          VANTAGE Platform
        </a>
        <br />
        <br />
        <a
          href="https://app-eu.clickdimensions.com/blob/controlriskscom-agyes/files/vantageservicesdescriptiontemplatevantagegateway01.10.23.pdf"
          tabIndex="-1"
          style={{ marginLeft: '20px' }}
        >
          Gateway
        </a>
        <br />
        <br />
        <a
          href="https://app-eu.clickdimensions.com/blob/controlriskscom-agyes/files/vantageservicesdescriptiontemplatevantageothercontrolrisksadvisoryservices01.10.23.pdf"
          tabIndex="-1"
          style={{ marginLeft: '20px' }}
        >
          Other Control Risks Advisory Services
        </a>
      </TermsText>

      {/* */}
      <br />
      <TermsSubHeading>7. Updates to Terms</TermsSubHeading>
      <TermsText>
        Control Risks may make changes to the Terms from time to time. You will be notified of any
        important changes. Any such changes shall not apply to any dispute between you and Control
        Risks arising prior to the date on which the revised Terms incorporating such changes were
        posted or when the Terms otherwise became effective. Please review the Terms regularly. If
        you do not agree to the amended Terms, you must stop using Gateway and the VANTAGE Services.
      </TermsText>

      {/* */}
      <br />
      <TermsSubHeading>8. Privacy</TermsSubHeading>
      <TermsText>
        You acknowledge that when you download, install, or use Gateway, Control Risks may use
        automatic means (including, for example, cookies and web beacons) to collect information
        about your device and about your use of Gateway. You also may be required to provide certain
        information about yourself as a condition to using Gateway or certain of its features or
        functionality. All information we collect through or in connection with Gateway is subject
        to our Privacy Policy (
        <a href="https://www.controlrisks.com/legal-1/privacy-policy" tabIndex="-1">
          https://www.controlrisks.com/legal-1/privacy-policy
        </a>
        ). By downloading, installing, using, and providing information to or through Gateway, you
        consent to all actions taken by us with respect to your information in compliance with the
        Privacy Policy.
      </TermsText>

      {/* */}
      <br />
      <TermsSubHeading>9. Updates</TermsSubHeading>
      <TermsText>
        Control Risks may from time to time in its sole discretion develop and provide Gateway
        updates, which may include upgrades, bug fixes, patches, other error corrections, and/or new
        features (collectively, including related documentation, “<strong>Updates</strong>”).
        Updates may also modify or delete in their entirety certain features and functionality. You
        agree that Control Risks has no obligation to provide any Updates or to continue to provide
        or enable any particular features or functionality.
      </TermsText>

      {/* */}
      <br />
      <TermsSubHeading>10. Transfer Terms for Existing VANTAGE Clients</TermsSubHeading>
      <TermsListComponent items={transferTemsforExistingClients} />

      <br />
      <TermsSubHeading>11. Multi-Factor Authentication</TermsSubHeading>
      <TermsListComponent items={multiFactorAuth} />
      <br />
      <TermsSubHeading>12. Free Trial Terms</TermsSubHeading>
      <TermsText>
        Control Risks may, at its sole discretion, offer a free trial of the VANTAGE Services. All
        free trials are governed by the Free Trial Terms (below).
      </TermsText>

      {/* */}
      <br />
      <TermsHeading>Free Trial Terms</TermsHeading>
      <TermsText>
        These terms (the “<strong>Free Trial Terms</strong>”) apply in addition to the Gateway
        General Terms of Use and the VANTAGE{' '}
        <a
          href="https://file-eu.clickdimensions.com/controlriskscom-agyes/files/2025-01-08-vantagegeneraltermsandconditions-final.pdf?m=1/13/2025%2012:58:29%20PM"
          tabIndex="-1"
        >
          General Terms and Conditions
        </a>
        , where you are participating in a free trial of the VANTAGE Services. In the event of a
        conflict between the Gateway General Terms of Use, the VANTAGE General Terms and Conditions
        and the Free Trial Terms, the Free Trial Terms shall prevail. The trial period with be for
        thirty (30) days from the date the earlier of when you: (i) activate your account and/or
        (ii) receive a report, or for such period as otherwise agreed in writing (the "
        <strong>Trial Period</strong>"). At the end of the Trial Period, if you have not entered
        into a subscription or Work Order, you will no longer have access to any data, reports or
        other materials available (the "<strong>Materials</strong>") from the VANTAGE Services.
      </TermsText>
      <TermsText>
        The definitions in the Gateway General Terms of Use shall apply to the Free Trial Terms.
      </TermsText>

      {/* */}
      <br />
      <TermsSubHeading>1. Licence; Restrictions on Use</TermsSubHeading>
      <TermsText>
        You are granted a non-exclusive, non-transferrable, limited licence to access and, where
        agreed, use for review purposes the VANTAGE Services and Materials from time to time made
        available to you. This licence includes:
      </TermsText>
      <TermsListComponent items={licenceRestrictionsIncludesFreeTrialTerms} />
      <TermsText>You must not:</TermsText>
      <TermsListComponent items={licenceRestrictionsMustNotFreeTrialTerms} />
      <TermsText>
        Except as specifically provided in this clause 1, you are prohibited from downloading,
        storing, reproducing, transmitting, displaying, copying, distributing, or using Materials
        retrieved from the VANTAGE Services. You may not print or download Materials without using
        the printing or downloading commands of the VANTAGE Services or your web browser.
        <br />
        All right, title, and interest (including all copyrights and other intellectual property
        rights) in the VANTAGE Services and Materials (in both print and machine-readable forms)
        belong to Control Risks or its third-party suppliers of materials. You acquire no
        proprietary interest in the VANTAGE Services, Materials, or copies thereof.
      </TermsText>

      {/* */}
      <br />
      <TermsSubHeading>2. Access to Services</TermsSubHeading>
      <TermsListComponent items={accessToServices} />

      {/* */}
      <TermsSubHeading>3. Limited Warranty</TermsSubHeading>
      <TermsListComponent items={limitedWarranty} />

      {/* */}
      <TermsSubHeading>4. Limitation of Liability</TermsSubHeading>
      <TermsListComponent items={limitationOfLiability} />
    </TermsContainer>
  );
};

export default TermsAndConditions;
